import { useQuery } from "react-query"
import { useMainContext } from "../../contexts/main"
import { filterFetch } from "../fetch-api/get"


export const useSwapHistoryQuery = (data) => {
    const {
        profile: { token },
    } = useMainContext()
    return useQuery('fetch-swap-history', () => filterFetch(data, token, 'swaps'), {
        enabled: !!token,
        select: (res) => res.data,
        refetchOnWindowFocus: false,
    })
}